import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { Grid, Page } from "../components/ComicCard";

export default function Discover({ market }) {
  const [genres, setGenres] = useState([]);
  const [q, setQ] = useState("");
  const [genre, setGenre] = useState("");
  const [sort, setSort] = useState("trending");
  const [comics, setComics] = useState(null);
  useEffect(() => { api.get("/genres").then((r) => setGenres(r.data)); }, []);
  useEffect(() => {
    const t = setTimeout(() => api.get("/comics", { params: { q, genre, sort, paid: market ? "1" : "" } }).then((r) => setComics(r.data)), 250);
    return () => clearTimeout(t);
  }, [q, genre, sort, market]);
  return (
    <Page>
      <div className="jx-tag jx-mint">{market ? "Buy issues, collections & series" : "Find your next obsession"}</div>
      <h1 className="text-4xl sm:text-5xl font-black mt-1">{market ? "Marketplace" : "Discover"}</h1>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <label className="flex-1 flex items-center gap-2 jx-surface rounded-full px-4 h-12"><Search size={18} className="jx-muted" />
          <input data-testid="discover-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search titles & stories" className="bg-transparent flex-1 outline-none focus:outline-none" /></label>
        <select data-testid="discover-sort-select" value={sort} onChange={(e) => setSort(e.target.value)} className="jx-surface rounded-full px-4 h-12">
          {[["trending", "Most read"], ["new", "Newest"], ["top", "Top rated"], ["liked", "Most liked"]].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar mt-4 pb-1">
        {["", ...genres].map((g) => <button key={g || "all"} data-testid={`genre-${g || "all"}`} onClick={() => setGenre(g)} className={`shrink-0 px-4 h-10 rounded-full text-sm border-2 transition-colors ${genre === g ? "bg-[var(--jx-pink)] border-[var(--jx-pink)] text-white" : "border-[var(--jx-border)] jx-muted"}`}>{g || "All"}</button>)}
      </div>
      <div className="mt-8">{!comics ? <div className="jx-muted">Loading…</div> : comics.length ? <Grid comics={comics} testid="discover-grid" /> : <div data-testid="discover-empty" className="jx-muted py-16 text-center">No comics match yet.</div>}</div>
    </Page>
  );
}
